module.exports = __webpack_public_path__ + "static/media/ticketfinder-bg.b3339c58.jpg";